import axios from 'axios';
import { API_URL } from '../../lib/api';

const o = { withCredentials: true };
const M = `${API_URL}/api/invoice-review/sav-manuel`;

export const savApi = {
    lookup: (immat) => axios.get(`${M}/lookup`, { ...o, params: { immat } }).then(r => r.data),
    options: () => axios.get(`${M}/options`, o).then(r => r.data),
    invoices: (q) => axios.get(`${M}/factures`, { ...o, params: { q } }).then(r => r.data),
    upload: (file) => { const f = new FormData(); f.append('file', file); return axios.post(`${M}/justificatifs`, f, o).then(r => r.data); },
    prepare: (body) => axios.post(`${M}/preparations`, body, o).then(r => r.data),
    preparations: () => axios.get(`${M}/preparations`, o).then(r => r.data),
    validate: (body) => axios.post(`${M}/valider`, body, o).then(r => r.data),
    attach: (sid, body) => axios.post(`${M}/dossiers/${sid}/justificatifs`, body, o).then(r => r.data),
    rapprochements: () => axios.get(`${M}/rapprochements`, o).then(r => r.data),
    rapprocher: (sid, vehicle_id) => axios.post(`${M}/dossiers/${sid}/rapprocher`, { vehicle_id }, o).then(r => r.data),
};

export const emptyVehicule = (immatriculation = '') => ({ immatriculation, marque: '', modele: '', version: '', motorisation: '', date_vente: '', kilometrage: '' });
export const vehiculeOk = (v) => !!(v && v.immatriculation?.trim().length >= 4 && v.marque?.trim() && v.modele?.trim());
